import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { encrypt , decrypt , getParams } from "../../../helpers/CryptoJs";

import { getPromotionDetail } from "../../../actions/promotionAction";
import { getlanguagelist } from "../../../helpers/changelanguage";
import FeedContent from "../../FeedContainer/FeedContent"
import FeedUser from "../../FeedContainer/FeedUser"
import FeedImage from "../../FeedContainer/FeedImage"
import FeedFooter from "../../FeedContainer/FeedFooter"



class PromotionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
          promotionId : decrypt(window.location.href.split('/')[4])
        };
        this.payNow = this.payNow.bind(this);
    }
    componentDidMount() { 
        this.props.getPromotionDetail({'promotion_id' : this.state.promotionId});  
    }
    UNSAFE_componentWillReceiveProps(nextProps){  
    }

    payNow(){
        window.location.href = this.props.promotiondetail.payment_url; 
    }
    generateFeedContent(feedList){
   
        let details = feedList;
        let post_user = {
          post_user_image : details.promotion_creator_image,
          post_user_membership : details.promotion_creator_membership,
          post_user_id : details.promotion_creator_id,
          post_user_name  :  details.promotion_creator_name 
        }
        let content = details.promotion_description;
        if((content != undefined) && (content.includes('href') == true)){
            content           = content.replace(/href='(.+?)'>/g, function(m, $1) {
                return 'href='+$1+' target="_blank" class="hyperlinkss">';
              
           })
        }
        let curLanguage = localStorage.getItem('userLanguage');
          return (
            <div className="post_box position-relative">
              <div className="position-absolute"><img src={curLanguage == 'en' ? "/assets/images/promoted_lebel_small.png" : "/assets/images/promoted_lebel_somali_small.png"} style={{float : "right"}} /></div>
              <div className="center_post">
                <div className="post_header">
                  <FeedUser post_user={post_user} post_date={details.start_date}/>
                
                </div>
                <div className="post_body">
                  <FeedContent content={content}/> 
                  {this.checkPostImage(details)}
                  
                </div>
              </div>
              <FeedFooter 
                total_reaction={details.total_reaction} 
                my_reaction={details.my_reaction}
                total_comment={details.total_comment} 
                total_share="" 
                data_type="Promotion" 
                feed_id=""
                post_id={details.id}
                position="post" 
                feed_reaction_details = {details.feed_reaction_details}
              />                
            </div>
          )
        
    }
      
    checkPostImage(details){
        return (
          (details.media_link != '') ? 
              <div className="post_content">
               <FeedImage 
                  media_details      = {details.media_details}
                  dynamic_class      = "post_img" 
                  setActiveImage     = {this.setActiveImage} 
                  currentFeed        = {this.state.urlFeedId}
                  currentActiveImage = {this.state.currentActiveImage} 
                  carousalFeed       = {this.state.carousalFeed} 
                  post_my_reaction   = {details.my_reaction}
                  post_total_reaction= {details.total_reaction}
                  post_total_comment = {details.total_comment}
                  post_total_share   = {details.total_share}
                /> 
              </div>
          : null
        )
    }
    render() {
        let languagelist  = getlanguagelist();
        let feedList = this.props.promotiondetail || {};
        let feedBox  = this.generateFeedContent(feedList);
        return (
            <div id="post_arr">
                
                {(Object.keys(feedList).length > 0) ? feedBox : null }
                {/*  <Pageloader/> */}
            </div>
        )
    }
}
const mapStateToProps = state => {
  return {
    
    promotiondetail    : state.promotiondetail.promotionDetail,   
    currentUserDetails : state.login,      
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPromotionDetail   : bindActionCreators(getPromotionDetail, dispatch),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionDetail));